/* eslint-disable */
const Month_Map = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
}

export default {
  收货人信息: 'Recipient information',
  新增收货地址: 'Add recipient address',
  '您还没有收货地址，赶快添加吧！': 'You have not added any recipient address yet. Please add one now!',
  收起: 'Collapse',
  更多地址: 'More addresses',
  姓名: 'Name',
  请输入收货人: 'Please enter the consignee',
  电话: 'Phone number',
  请输入联系电话: 'Please enter the phone number',
  地址: 'Address',
  详细地址: 'Detailed Address',
  请输入详细地址: 'Please enter the detailed address',
  '保 存': 'Save',
  '取 消': 'Cancel',
  长度不可以超过50个字符: 'The length cannot exceed 50 characters',
  长度不可以超过20个字符: 'The length cannot exceed 20 characters',
  请选择地址: 'Please select an address',
  长度不可以超过100个字符: 'The length cannot exceed 100 characters',
  退出: 'Log out',
  首页: 'Homepage',
  我的文件: 'My files',
  企业文件: 'Enterprise files',
  我的模板: 'My templates',
  企业模板: 'Enterprise templates',
  审批管理: 'Approval',
  用户中心: 'User center',
  费用中心: 'Financial Center',
  证据中心: 'Evidence center',
  发票寄送信息: 'Invoice delivery information',
  顺丰快递价格: 'SF Express prices',
  元: 'Yuan',
  支付快递费: 'Pay courier fee',
  货到付款: 'Cash on delivery',
  '注意：目前暂不支持开具快递费发票，您可选择“货到付款”后向顺丰快递索要发票。':
    'Note: Currently, we do not support invoicing for courier fees. You can choose "cash on delivery" and request an invoice from SF Express.',
  江苏省: 'Jiangsu Province',
  浙江省: 'Zhejiang Province',
  上海市: 'Shanghai',
  西藏自治区: 'Tibet Autonomous Region',
  新疆维吾尔自治区: 'Xinjiang Uygur Autonomous Region',
  宁夏回族自治区: 'Ningxia Hui Autonomous Region',
  澳门特别行政区: 'Macao Special Administrative Region',
  香港特别行政区: 'Hong Kong Special Administrative Region',
  e签宝: 'eSign',
  '快速选择：': 'Quick selection:',
  序号: 'No.',
  服务名称: 'Service name',
  '本订单价格（元/次）': 'Price of this order (yuan/time)',
  '被转售方价格（元/次）': 'Price for resale party (yuan/time)',
  '实际价格（元/次）': 'Actual price (yuan/time)',
  '设置调价倍数：': 'Set price adjustment multiple:',
  应用: 'Apply',
  '确定后系统将按本订单价格*调价倍数更新被转售方价格':
    'After confirmation, the system will update the resale party price according to the order price * adjustment multiple',
  '请输入1-10以内的数字，最多1位小数': 'Please enter a number within 1-10 with up to 1 decimal place',
  取消: 'Cancel',
  确定: 'Confirm',
  知道了: 'Got it',
  '签署密码:': 'Signing password:',
  请输入签署密码: 'Please enter signature password',
  输入价格不符合规范: 'Entered price is not compliant',
  '此价格低于本订单价格，不能提交': 'This price is lower than the order price and cannot be submitted',
  还未勾选子服务项: 'Sub-service item is not selected',
  存在已勾选但未设置被转售方价格的子服务项:
    'There are sub-service items that have been selected but the resale party price has not been set',
  充值子项允许0元计费: 'Rechargeable sub-item can be billed at 0 yuan',
  '元/次': 'yuan/time',
  类别: 'Category',
  服务状态: 'Service status',
  价格审核中: 'Price under review',
  已开通: 'Activated',
  未开通: 'Not activated',
  '价格（元/次）': 'Price (yuan/time)',
  标准价: 'Standard price',
  一月: 'January',
  二月: 'February',
  三月: 'March',
  四月: 'April',
  五月: 'May',
  六月: 'June',
  七月: 'July',
  八月: 'August',
  九月: 'September',
  十月: 'October',
  十一月: 'November',
  十二月: 'December',
  消费时间: 'Consumption time',
  平台名称: 'Platform name',
  签署人: 'Signer',
  签署ID: 'Signature ID',
  消费数量: 'Consumption quantity',
  扣费方: 'Debtor',
  签署任务名称: 'Signature task name',
  签署任务ID: 'Signature task ID',
  消费主体: 'Consumer subject',
  子服务名称: 'Sub-service name',
  使用方: 'User',
  账号ID: 'Account ID',
  消费金额: 'Consumption amount',
  业务ID: 'Business ID',
  证件号: 'ID Number',
  结果描述: 'Result description',
  存证类型: 'Certification type',
  存证份数: 'Number of certifications',
  存证编号: 'Certification number',
  持有人名字: 'Holder name',
  CA通道名称: 'CA channel name',
  出证申请人: 'Certification applicant',
  出证编号: 'Certification number',
  订单号: 'Order number',
  出证类型: 'Certification type',
  合同数: 'Number of contracts',
  实际消费数: 'Actual consumption',
  AI类型: 'AI type',
  AI编号: 'AI number',
  授权企业GID: 'Authorized enterprise GID',
  被授权企业GID: 'Authorized enterprise GID',
  使用情况: 'Usage',
  国家开发银行: 'China Development Bank',
  中国工商银行: 'Industrial and Commercial Bank of China',
  中国农业银行: 'Agricultural Bank of China',
  中国银行: 'Bank of China',
  中国建设银行: 'China Construction Bank',
  中国邮政储蓄银行: 'China Postal Savings Bank',
  交通银行: 'Bank of Communications',
  招商银行: 'China Merchants Bank',
  上海浦东发展银行: 'Shanghai Pudong Development Bank',
  兴业银行: 'Industrial Bank',
  华夏银行: 'Huaxia Bank',
  广东发展银行: 'China Guangdong Development Bank',
  中国民生银行: 'China Minsheng Bank',
  中信银行: 'CITIC Bank',
  中国光大银行: 'China Everbright Bank',
  恒丰银行: 'Hengfeng Bank',
  浙商银行: 'Zhejiang Chouzhou Commercial Bank',
  渤海银行: 'Bohai Bank',
  平安银行: 'Ping An Bank',
  上海农村商业银行: 'Shanghai Rural Commercial Bank',
  玉溪市商业银行: 'Yuxi City Commercial Bank',
  尧都农商行: 'Yaodu Rural Commercial Bank',
  北京银行: 'Bank of Beijing',
  上海银行: 'Bank of Shanghai',
  江苏银行: 'Jiangsu Bank',
  杭州银行: 'Hangzhou Bank',
  南京银行: 'Nanjing Bank',
  宁波银行: 'Ningbo Bank',
  徽商银行: 'Huishang Bank',
  长沙银行: 'Changsha Bank',
  成都银行: 'Chengdu Bank',
  重庆银行: 'Chongqing Bank',
  大连银行: 'Dalian Bank',
  南昌银行: 'Nanchang Bank',
  福建海峡银行: 'Fujian Haixia Bank',
  汉口银行: 'Hankou Bank',
  温州银行: 'Wenzhou Bank',
  青岛银行: 'Qingdao Bank',
  台州银行: 'Taizhou Bank',
  嘉兴银行: 'Jiaxing Bank',
  常熟农村商业银行: 'Changshu Rural Commercial Bank',
  南海农村信用联社: 'Nanhai Rural Credit Union',
  常州农村信用联社: 'Changzhou Rural Credit Union',
  内蒙古银行: 'Inner Mongolia Bank',
  绍兴银行: 'Shaoxing Bank',
  顺德农商银行: 'Shunde Rural Commercial Bank',
  吴江农商银行: 'Wujiang Rural Commercial Bank',
  齐商银行: 'Qishang Bank',
  贵阳市商业银行: 'Guiyang City Commercial Bank',
  遵义市商业银行: 'Zunyi City Commercial Bank',
  湖州市商业银行: 'Huzhou City Commercial Bank',
  龙江银行: 'Longjiang Bank',
  晋城银行JCBANK: 'Jincheng Bank',
  浙江泰隆商业银行: 'Zhejiang Tailong Commercial Bank',
  广东省农村信用社联合社: 'Guangdong Rural Credit Union',
  东莞农村商业银行: 'Dongguan Rural Commercial Bank',
  浙江民泰商业银行: 'Zhejiang Mintai Commercial Bank',
  广州银行: 'Guangzhou Bank',
  辽阳市商业银行: 'Liaoyang City Commercial Bank',
  江苏省农村信用联合社: 'Jiangsu Rural Credit Union',
  廊坊银行: 'Langfang Bank',
  浙江稠州商业银行: 'Zhejiang Chouzhou Commercial Bank',
  德阳商业银行: 'Deyang Commercial Bank',
  晋中市商业银行: 'Jinzhong City Commercial Bank',
  苏州银行: 'Suzhou Bank',
  桂林银行: 'Guilin Bank',
  乌鲁木齐市商业银行: 'Urumqi City Commercial Bank',
  成都农商银行: 'Chengdu Rural Commercial Bank',
  张家港农村商业银行: 'Zhangjiagang Rural Commercial Bank',
  东莞银行: 'Dongguan Bank',
  莱商银行: 'Laishang Bank',
  北京农村商业银行: 'Beijing Rural Commercial Bank',
  天津农商银行: 'Tianjin Rural Commercial Bank',
  上饶银行: 'Shangrao Bank',
  富滇银行: 'Fudian Bank',
  重庆农村商业银行: 'Chongqing Rural Commercial Bank',
  鞍山银行: 'Anshan Bank',
  宁夏银行: 'Ningxia Bank',
  河北银行: 'Hebei Bank',
  华融湘江银行: 'Huarong Xiangjiang Bank',
  自贡市商业银行: 'Zigong City Commercial Bank',
  云南省农村信用社: 'Yunnan Rural Credit Cooperative',
  吉林银行: 'Jilin Bank',
  东营市商业银行: 'Dongying City Commercial Bank',
  昆仑银行: 'Kunlun Bank',
  鄂尔多斯银行: 'Ordos Bank',
  邢台银行: 'Xingtai Bank',
  晋商银行: 'Jinshang Bank',
  天津银行: 'Tianjin Bank',
  营口银行: 'Yingkou Bank',
  吉林农信: 'Jilin Rural Credit Cooperative',
  山东农信: 'Shandong Rural Credit Cooperative',
  西安银行: "Xi'an Bank",
  河北省农村信用社: 'Hebei Rural Credit Union',
  宁夏黄河农村商业银行: 'Ningxia Yellow River Rural Commercial Bank',
  贵州省农村信用社: 'Guizhou Rural Credit Cooperative',
  阜新银行: 'Fuxin Bank',
  湖北银行黄石分行: 'Hubei Bank Huangshi Branch',
  浙江省农村信用社联合社: 'Zhejiang Rural Credit Union Cooperative',
  新乡银行: 'Xinxiang Bank',
  湖北银行宜昌分行: 'Hubei Bank Yichang Branch',
  乐山市商业银行: 'Leshan City Commercial Bank',
  江苏太仓农村商业银行: 'Jiangsu Taicang Rural Commercial Bank',
  驻马店银行: 'Zhumadian Bank',
  赣州银行: 'Ganzhou Bank',
  无锡农村商业银行: 'Wuxi Rural Commercial Bank',
  广西北部湾银行: 'Beibu Gulf Bank',
  广州农商银行: 'Guangzhou Rural Commercial Bank',
  江苏江阴农村商业银行: 'Jiangsu Jiangyin Rural Commercial Bank',
  平顶山银行: 'Pingdingshan Bank',
  泰安市商业银行: "Tai'an City Commercial Bank",
  南充市商业银行: 'Nanchong City Commercial Bank ',
  重庆三峡银行: 'Chongqing Three Gorges Bank',
  中山小榄村镇银行: 'Zhongshan Xiaolan Village Bank',
  邯郸银行: 'Handan Bank',
  库尔勒市商业银行: 'Korla City Commercial Bank',
  锦州银行: 'Jinzhou Bank',
  齐鲁银行: 'Qilu Bank ',
  青海银行: 'Qinghai Bank',
  阳泉银行: 'Yangquan Bank',
  盛京银行: 'Shengjing Bank ',
  抚顺银行: 'Fushun Bank',
  郑州银行: 'Zhengzhou Bank',
  深圳农村商业银行: 'Shenzhen Rural Commercial Bank ',
  潍坊银行: 'Weifang Bank',
  九江银行: 'Jiujiang Bank',
  江西省农村信用: 'Rural Credit in Jiangxi Province',
  河南省农村信用: 'Rural Credit in Henan Province',
  甘肃省农村信用: 'Rural Credit in Gansu Province',
  四川省农村信用: 'Rural Credit in Sichuan Province',
  广西省农村信用: 'Rural Credit in Guangxi Province',
  陕西信合: 'Shaanxi Xinhe',
  武汉农村商业银行: 'Wuhan Rural Commercial Bank',
  宜宾市商业银行: 'Yibin Commercial Bank',
  昆山农村商业银行: 'Kunshan Rural Commercial Bank',
  石嘴山银行: 'Shizuishan Bank',
  衡水银行: 'Hengshui Bank',
  信阳银行: 'Xinyang Bank',
  鄞州银行: 'Yinzhou Bank ',
  张家口市商业银行: 'Zhangjiakou Commercial Bank',
  许昌银行: 'Xuchang Bank',
  济宁银行: 'Jining Bank',
  开封市商业银行: 'Kaifeng Commercial Bank',
  威海市商业银行: 'Weihai Commercial Bank',
  湖北银行: 'Hubei Bank',
  承德银行: 'Chengde Bank',
  丹东银行: 'Dandong Bank',
  金华银行: 'Jinhua Bank',
  朝阳银行: 'Chaoyang Bank',
  临商银行: 'Linshang Bank',
  包商银行: 'Baoshang Bank',
  兰州银行: 'Lanzhou Bank',
  周口银行: 'Zhoukou Bank',
  德州银行: 'Texas Bank',
  三门峡银行: 'Sanmenxia Bank',
  安阳银行: 'Anyang Bank',
  安徽省农村信用社: 'Anhui Rural Credit Cooperative',
  湖北省农村信用社: 'Hubei Rural Credit Cooperative',
  湖南省农村信用社: 'Hunan Rural Credit Cooperative',
  广东南粤银行: 'Guangdong Nanyue Bank',
  洛阳银行: 'Luoyang Bank',
  农信银清算中心: 'Agricultural Credit Bank Clearing Center',
  城市商业银行资金清算中心: 'City Commercial Bank Fund Clearing Center',
  新签: 'New sign',
  续签: 'Renewal',
  我的账户: 'My Account',
  我的订单: 'My Order',
  我的账单: 'My Bill',
  '今天 {slot1}': 'Today {slot1}',
  '昨天 {slot1}': 'Yesterday {slot1}',
  当前信息: 'Current information',
  '用户ID：': 'User ID:',
  '账号名称：': 'Account name:',
  '证件类型：': 'Certificate type:',
  '证件号：': 'ID number:',
  '联系地址：': 'Contact address:',
  '联系电话：': 'Contact phone:',
  '姓名：': 'Name:',
  进入统一用户中心: 'Enter unified user center',
  当前: 'Currently',
  企业: 'Company',
  个人: 'Personal',
  '并无实名认证,请前往用户中心实名认证后再进行查看。':
    'There is no real name verification, please go to the user center for real name verification before checking.',
  开始实名认证: 'Start real-name verification',
  提现申请: 'Withdrawal application',
  可提现余额: 'Available balance',
  提现中: 'Withdrawing',
  提现金额: 'Withdrawal amount',
  '为保障您所在的主体账户资金安全，一天内一个主体仅能操作提现1次，请谨慎操作！':
    'To ensure the security of funds in your main account, a main body can only operate one withdrawal per day. Please operate with caution!',
  '请输入大于1.00元的数字': 'Greater than 1.00',
  提现至银行账户: 'Withdraw to bank account',
  '请保证银行账户信息准确且未失效，否则将无法打款成功！':
    'Please ensure that the bank account information is accurate and valid, otherwise the payment will not be successful!',
  开户行全称: 'Full name of bank',
  请输入开户行关键词: 'Please enter the bank keyword',
  提现银行: 'Withdrawal bank',
  银行账户名: 'Bank account name',
  银行账号: 'Bank account',
  修改银行卡: 'Modify bank card',
  确认提现: 'Confirm withdrawal',
  提现验证: 'Withdrawal verification',
  '为保障您的账户安全，请输入签署密码：': 'To ensure the security of your account, please enter your signature password:',
  '管理员手机号：': 'Administrator mobile number:',
  '手机号：': 'Mobile',
  '邮箱：': 'Email:',
  '验证码：': 'Verification code:',
  请输入6位验证码: 'Please enter a 6-digit verification code',
  '{time} 秒后获取': '{time} seconds to get',
  发送验证码: 'Send verification code',
  使用动态验证码: 'Use dynamic verification code',
  使用签署密码: 'Use signature password',
  '还没有签署密码？': "Don't have a signature password yet?",
  去设置: 'Go set up',
  '确 定': 'Confirm',
  请输入提现金额: 'Please enter the withdrawal amount',
  '请输入正确的提现金额，保留2位有效数字': 'Please enter the correct withdrawal amount, retaining 2 significant digits',
  '输入金额不能超过可提现余额(单次最多提现300元)':
    'The entered amount cannot exceed the available balance (maximum withdrawal of 300 yuan per transaction)',
  签署密码: 'Signing Password',
  验证码: 'Verification code',
  '{text}不能为空': '{text} cannot be empty',
  验证码格式不正确: 'Incorrect verification code format',
  请输入开户行全称: 'Please enter full name of the bank',
  请输入银行账号: 'Please enter bank account',
  '银行卡账号长度不能小于8位(数字)': 'The length of the bank card account number cannot be less than 8 digits (numbers)',
  参数错误: 'Parameter error',
  '您的可提现金额小于 1 元，不可提现！': 'Your available withdrawal amount is less than 1 yuan, and you cannot withdraw!',
  '确认是否提现?': 'Confirm whether to withdraw?',
  提示: 'Prompt',
  '验证码已发送!': 'The verification code has been sent!',
  '发送验证码失败!': 'Failed to send verification code!',
  '您已发起{amount}元提现申请！': 'You have initiated a withdrawal application for {amount} yuan!',
  '抱歉，您发起的{amount}元提现申请失败了！': 'Sorry, your withdrawal application for {amount} yuan failed!',
  'e签宝将在2~3个工作日内处理您的提现申请，提现结果可登录钱包页面查看或及时查收短信。':
    'eSign will process your withdrawal application within 2-3 working days. You can view the withdrawal result by logging in to the wallet page or receiving text messages in time.',
  返回: 'Back',
  重新申请: 'Reapply',
  '提示：如相应资金长时间未到账，请咨询相关银行或拨打客服热线：400-087-8198。':
    'Note: If the corresponding funds have not been received for a long time, please consult the relevant bank or call the customer service hotline: 400-087-8198.',
  我的账单记录: 'My billing record',
  '提示：当月用量统计截止昨天24:00。': 'Reminder: Usage statistics for the current month are as of 24:00 yesterday.',
  账单时间: 'Billing time',
  选择日期: 'Select date',
  请选择: 'Please select',
  请输入: 'Please enter',
  产品名称: 'Product Name',
  订单编号: 'Order number',
  查询: 'Query',
  清空: 'Clear',
  导出: 'Export',
  '共用掉{amount}{units}': 'Total usage {amount} {units}',
  暂无更多数据: 'No more data available',
  导出消费记录: 'Export consumption records',
  已导出记录查询: 'Exported record query',
  请选择产品名称: 'Please select the product name',
  月度区间: 'Monthly interval',
  请选择月度区间: 'Please select the monthly interval',
  开始月份: 'Start month',
  结束月份: 'End month',
  '消费记录生成中，请稍等…': 'Consumption records are being generated, please wait...',
  至: 'to',
  明细下载: 'Detail download',
  关闭: 'Close',
  已导出消费记录: 'Consumption records exported',
  请选择产品名称筛选: 'Please select a product name filter',
  全部产品: 'All products',
  导出成功: 'Export successful',
  导出失败: 'Export failed',
  '(已过期)': '(Expired)',
  暂无数据: 'No data available',
  好的: 'OK',
  请选择产品: 'Please select a product',
  暂不支持超过三个月时间宽度的导出操作: 'Export operations wider than three months are not supported',
  请输入产品名称: 'Please enter the product name',
  请输入月度区间: 'Please enter the monthly interval',
  发货时间: 'Delivery time',
  '共收货{amount}个': 'Total received {amount}',
  导出发货记录: 'Export shipping record',
  发货ID: 'Delivery ID',
  发货状态: 'Status',
  发件人: 'Sender',
  发件数量: 'Quantity',
  收件人: 'Recipient',
  '{month}月': function (ctx) {
    if (ctx.values && ctx.values.month) {
      const month = ctx.values.month
      return `${Month_Map[month]} `
    }
    return ''
  },
  '发货记录生成中，请稍等…': 'shipping records are being generated, please wait...',
  '发起的发货记录导出请求已经生成完毕。': 'The export request for shipping records you initiated has been completed.',
  '您的转售存在转售数量小于搭售要求的规格{slot}份的操作，不会搭售对应套餐':
    'The number of resales you operate is less than the required specification of {slot} units, therefore the system will not bundle the corresponding package.',
  '注意：您的转售存在转售数量小于搭售要求的规格{slot}份的操作，不会搭售对应套餐':
    'The number of resales you operate is less than the required specification of {slot} units, therefore the system will not bundle the corresponding package.',
  下载: 'Download',
  待发货: 'To be shipped',
  下单失败: 'Order failed',
  已发货: 'Shipped',
  已取消: 'Cancelled',
  需追回: 'Requires recovery',
  已追回: 'Recovered',
  已冻结: 'Frozen',
  已收货: 'Received',
  查看发票: 'View invoice',
  拼命加载中: 'Loading',
  下载发票: 'Download invoice',
  '开票系统维护中，请稍后再试': 'The invoicing system is under maintenance, please try again later',
  操作转售: 'Resale',
  订单授权: 'Order authorization',
  '转售订单不可消费，若您在转售后希望使用此订单部分份额，请对您自己转售部分份额，请注意，所有转售份额不可取消；':
    'Resold orders cannot be consumed. If you want to use part of the resold share after reselling, please note that all resold shares cannot be cancelled.',
  '*可授权企业用户须线下走授权申请': 'Enterprise users who can be authorized must apply for authorization offline',
  '订单编号：': 'Order number:',
  产品规格数量: 'Quantity',
  有效时间: 'Effective time',
  已转售量: 'Resale',
  已使用量: 'Used',
  剩余可转售量: 'Remaining resellable',
  当前余量: 'Balance',
  付款状态: 'Status',
  无限: 'Unlimited',
  待支付: 'Pending Payment',
  已支付: 'Paid',
  付款中: 'Payment in progress',
  未支付: 'Not paid',
  '总共可转售：': 'Total resellable:',
  当前总共可授权数量: 'Current total number of authorized quantities',
  添加授权方: 'Add authorized person',
  可授权用户: 'Authorized user',
  '选择：': 'Selection:',
  请输入授权用户名称: 'Please enter the authorized user name',
  无信息: 'No information',
  全选: 'Select all',
  已选: 'Selected',
  选择授权方名称: 'Select the authorized party name',
  方式选择: 'Mode selection',
  最大可用量: 'Maximum available quantity',
  操作: 'Operation',
  配额: 'Quota',
  共享: 'Shared',
  请输入数字: 'Please enter a number',
  选择被转售方名称: 'Select the name of the resold party',
  '（每次最多新增5个）': '(Up to 5 at a time)',
  有效期: 'Valid period',
  '被转售方可使用此转售订单的时间范围，此时间范围应处于主订单有效期范围内；':
    'The resold party can use the resold order within the validity period of the main order;',
  请输入相关企业完整证件号或个人完整身份证:
    'Please enter the complete certificate number of the relevant enterprise or the complete ID number of the individual',
  开通子服务: 'Enable sub-services',
  '+ 添加': '+ Add',
  下一步: 'Next step',
  开通子服务项: 'Enable sub-service items',
  重复授权提醒: 'Repeat authorization reminder',
  '共享模式同一个订单一个用户只能共享一次，如下用户存在重复共享':
    'In shared mode, one user can only share an order once. The following users have duplicate shares',
  重复被授权用户: 'Duplicate authorized users',
  '请输入相关企业完整证件号,每次最多添加20个,可多次':
    'Please enter the complete certificate number of the relevant enterprise, up to 20 at a time, multiple times',
  '请输入个人完整身份证号,每次最多添加20个,可多次':
    'Please enter the complete ID number of the individual, up to 20 at a time, multiple times',
  年: 'Year',
  月: 'Month',
  日: 'Day',
  请输入30位以内字母或数字: 'Please enter up to 30 letters or numbers',
  您输入的相关企业完整证件号或个人完整身份证不存在:
    'The relevant enterprise complete certificate number or full ID number you entered does not exist',
  '同个客户同个商品仅支持一种授权模式，若需此操作，请先取消原有授权方式！':
    'The same customer and product can only support one authorization mode. If you need this operation, please cancel the original authorization method first!',
  添加的授权数量不能大于可授权数量: 'The number of authorized quantities added cannot exceed the number of authorized quantities',
  '生效日期: {slot1} ~ {slot2}': 'Effective date: {slot1} ~ {slot2}',
  以上被转售方的有效期超出了您主订单的有效期: "The above resold party's validity period exceeds the validity period of your main order",
  '{slot1}，请您调整他们的有效期；': '{slot1}, please adjust their validity period;',
  '当前已有生效中的相同产品订单,有效期截止{slot1},请您确认生效日期和有效期！':
    'There is currently a valid product order with the same product. The validity period ends on {slot1}，Please confirm the effective date and validity period！',
  请您确认生效日期和有效期: 'Please confirm the effective date and validity period',
  请添加被授权方: 'Please add the authorized party',
  授权数量不能为0: 'The number of authorized quantities cannot be 0',
  请输入被转售方: 'Please enter the resold party',
  '{slot1}还未选子服务项/添加价格，它将无法使用{slot2}订单，请先勾选再确认转售':
    '{slot1} has not selected a sub-service item/added a price, it will not be able to use the {slot2} order, please check before confirming the resale',
  '请输入最小为1的整数,总共可转售量为{slot1}':
    'Please enter an integer greater than or equal to 1, and the total resellable quantity is {slot1}',
  请选择生效日期: 'Please select the effective date',
  超过总量: 'Exceeding the total amount',
  有效期提醒: 'Validity period reminder',
  订单提醒: 'Order reminder',
  '注意！本次操作配额总量大于90%，授权企业该产品余量由{slot1}变更为{slot2}，可能导致授权企业与其他被授权企业的运行中的服务中断，请核实后确认':
    'Attention! The total quota for this operation is more than 90%. The remaining balance of this product for the authorized company has been changed from {slot1} to {slot2}, which may cause interruptions in the running services of the authorized company and other authorized companies. Please confirm after verifying.',

  '提示：被授权企业下有生效中的订单，本次授权操作后，依旧会优先扣减原订单余量':
    'Note: There are effective orders under the authorized company. After this authorization operation, the remaining balance of the original order will still be deducted first.',
  配额数量必须大于0: 'The quota quantity must be greater than 0',
  配额总数不能超过当前可授权数量: 'The total quota cannot exceed the current number of authorized quantities',
  开票: 'Invoicing',
  '提示：可能有部分金额已开过发票，此处不计入可开票金额内。':
    'Reminder: Some amounts may have been invoiced, and they are not included in the amount that can be invoiced here.',
  合并: 'Merge',
  '开票总金额：': 'Total invoiced amount:',
  '合并开票总金额：': 'Combined invoicing amount:',
  '开票订单：': 'Invoiced orders:',
  '{slot1}笔': '{slot1} transactions',
  '{slot1}元': '{slot1} Yuan',
  '（其中 {slot1}，将按归属公司分别合并开票）': '({slot1} will be invoiced separately according to the company of ownership)',
  开票信息: 'Invoicing information',
  '发票抬头:': 'Invoice title:',
  '纳税人识别号:': 'Taxpayer ID:',
  请输入内容: 'Please enter content',
  '发票类型:': 'Invoice type:',
  '电子票开具后，我们会直接通过邮件向您发送对应票据':
    'After the e-ticket is issued, we will send you the corresponding ticket directly by email',
  增值税普通发票: 'Value-added tax ordinary invoice',
  增值税专用发票: 'Value-added tax special invoice',
  '发票形式:': 'Invoice format:',
  纸质发票: 'Paper invoice',
  电子发票: 'Electronic invoice',
  开户银行: 'Bank name',
  请选择开户银行: 'Please select',
  开票地址: 'Invoice address',
  开票电话: 'Billing phone number',
  '开票电话，例:18899990000 或 0571-12345678-001 或 400-888-8888': 'Phone number, e.g.: 18899990000 or 0571-12345678-001 or 400-888-8888',
  '开票备注(非实际开票上的备注内容)': 'Billing remarks (not actual billing remarks)',
  '开票备注:': 'Remarks:',
  '若有特殊开票注意事项，请留言，系统将根据您的需求流转至开票人员':
    'If there are special billing precautions, please leave a message, the system will circulate to the billing staff according to your needs',
  确认提交: 'Confirm',
  请输入纳税人识别号: 'Please enter taxpayer ID',
  请输入开票地址: 'Please enter the billing address',
  请输入接收邮箱: 'Please enter your email address',
  请正确填写接收邮箱: 'Please fill in the receiving email correctly',
  请填写开票电话: 'Please fill in the billing phone number',
  '请正确填写联系号码：例如：18899990000 或 0571-12345678-001 或 400-888-8888':
    'Please fill in the contact number correctly: e.g.: 18899990000 or 0571-12345678-001 or 400-888-8888',
  '暂不支持500元以下开具增值税专用发票，如需帮助可拨打客服热线：400-087-8198':
    'VAT special invoices below 500 yuan are not currently supported. If you need help, please call the customer service hotline: 400-087-8198',
  '开票金额不能为0!': 'The billing amount cannot be 0!',
  '请先设置收货地址 !': 'Please set the shipping address first!',
  '开票银行名称和开票银行账户需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息':
    'The billing bank name and billing bank account need to be entered at the same time or left empty at the same time. You have entered one of the information, please fill in the complete information',
  '开票地址和开票电话需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息':
    'The billing address and billing phone number need to be entered at the same time or left empty at the same time. You have entered one of the information, please fill in the complete information',
  '开票地址过长，系统无法支持，建议字数控制在40个字以内':
    'The billing address is too long and the system cannot support it. It is recommended to control the number of words within 40 words',
  '抱歉，单次发票可开具金额为99999.99，请联系客服获取发票。':
    'Sorry, the maximum amount that can be invoiced at a time is 99999.99. Please contact customer service to obtain the invoice.',
  '{slot1} {slot2} 笔': '{slot1} {slot2} transactions',
  剩余可用总量: 'Remaining available total',
  预扣用量: 'Prepaid usage',
  剩余可转售总量: 'Total remaining salable quantity',
  查看账单: 'Bill',
  转售记录: 'Resale record',
  授权记录: 'Authorization record',
  账单记录: 'Bill record',
  发货记录: 'Shipping record',
  '通知：您有一个原购买合同解约协议待确认。': 'Notice: You have a contract termination agreement awaiting confirmation.',
  查看详情: 'Details',
  '通知：您有一个结算单待确认。': 'Notice: You have a settlement waiting for confirmation.',
  '提示：除企业管理员、计费管理员可见所有订单外，其他身份用户仅可见自己下单的订单。':
    'Note: Except for enterprise administrators and billing administrators who can see all orders, other identity users can only see orders they have placed.',
  '下单时间：': 'Order time:',
  开始日期: 'Start Date',
  结束日期: 'End Date',
  '订购产品：': 'Purchased product:',
  '订单状态：': 'Order status:',
  '特殊订单类型：': 'Special order type:',
  转售订单: 'Resale order',
  授权订单: 'Authorization order',
  后付费订单: 'Postpaid order',
  '支付状态：': 'Payment status:',
  已失效: 'Expired',
  '{slot1} 于 {slot2}授权此订单': '{slot1} authorizes this order from {slot2}',
  被授权订单: 'Authorized orders',
  '订单金额：': 'Order amount:',
  '合同编号：': 'Contract number:',
  '单价：': 'Unit price:',
  分开计价详单: 'Separate pricing details',
  '元/': 'Yuan/',
  待生效: 'Pending activation',
  生效中: 'In effect',
  交易成功: 'Transaction successful',
  已停用: 'Disabled',
  配置上线时间: 'Configuration online time',
  下载License: 'License',
  下载license授权文件后请在指定的系统中导入使用:
    'After downloading the license authorization file, please import and use it in the designated system',
  在线支付: 'Online payment',
  我要开票: 'Invoice',
  开通新的子服务: 'Enable a new sub-service',
  再次购买: 'Buy again',
  查看历史结算: 'Historical settlement',
  授权: 'Authorization',
  物流信息: 'Logistics',
  拼命处理中: 'Desperately processing',
  我已阅读并同意: 'I have read and agree',
  不想解约: "Don't want to cancel",
  同意并下载: 'Agree and download',
  '“实际消费金额”包含您已转售的量': 'The actual consumption amount" includes the amount you have resold',
  结算周期: 'Settlement cycle',
  '消费金额(元)': 'Consumption amount (Yuan)',
  '已支付(元)': 'Paid (Yuan)',
  '未支付(元)': 'Unpaid (Yuan)',
  '注意：上线时间配置后不可更改，即订单在此时间开始进入生效期。若您购买的该产品需要技术对接，请和您的客户成功经理沟通确认后配置上线时间！':
    'Note: The online time configuration cannot be changed. The order will enter the effective period at this time. If the product you purchased requires technical docking, please confirm with your customer success manager before configuring the online time!',
  '指定时间：': 'Designated time:',
  开始生效: 'Start to take effect',
  原订单结束后自动延续: 'Automatically renew after the original order ends',
  项开通: 'item enabling',
  上一步: 'Previous Step',
  开通服务项: 'Enable service item',
  确定开通: 'Confirm',
  确定合并开票: 'Confirm',
  合并开票: 'Merge billing',
  普通订单: 'Ordinary order',
  其他订单: 'Other order',
  已终止: 'Terminated',
  冻结中: 'Freezing',
  支付中: 'Paying',
  操作成功: 'Operation successful',
  '您已开通新的认证服务项，即刻可以使用！': 'You have enabled a new certification service item and can use it immediately!',
  认证服务开通成功: 'Certification service enabled successfully',
  请选择服务名称: 'Please select the service name',
  请选择订单: 'Please select the order',
  发票审核中: 'Invoice under review',
  '开票中，请稍后': 'Invoicing, please wait',
  '结算单-{slot1}.pdf': 'Settlement-{slot1}.pdf',
  '账单修改中，不支持操作': 'The bill is being modified and cannot be operated',
  确认订单信息: 'Confirm order information',
  '订单生效时间:': 'Order effective time:',
  '您可以设置订单开始生效时间，即以此时间开始方可使用相关服务':
    'You can set the order start time, and related services can only be used from this time',
  您可以设置订单开始时间为延续当前使用订单的结束之时: 'You can set the start time of the order to the end of the current use order',
  套餐名称: 'Package name',
  '套餐附带：': 'Package included:',
  购买个数: 'Purchase quantity',
  产品规格: 'Product specifications',
  '总数量：': 'Total quantity:',
  '标准价格（元）': 'Standard price (Yuan)',
  优惠方式: 'Discount',
  '合计价格（元）': 'Total price (Yuan)',
  不开发票: 'Do not issue an invoice',
  开发票: 'Issue an invoice',
  确认发票信息: 'Confirm invoice information',
  发票抬头: 'Invoice title',
  纳税人识别号: 'Taxpayer ID',
  发票类型: 'Invoice type',
  请选择发票类型: 'Please select the invoice type',
  发票形式: 'Invoice format',
  '购买方：': 'Buyer:',
  '商品标准价格：': 'Standard price of goods:',
  '已优惠金额：': 'Amount of discount:',
  '发票快递费：': 'Invoice postage:',
  '优惠券：': 'Coupon:',
  有可用优惠券: 'There are available coupons',
  已输入优惠券: 'Coupon entered',
  '总金额：': 'Total amount:',
  '我已阅读，同意此协议': 'I have read and agree to this agreement',
  点此查看协议: 'Click here to view agreement',
  提交订单: 'Submit order',
  使用优惠券: 'Use coupons',
  优惠券编号: 'Coupon number',
  请输入优惠券编号: 'Please enter the coupon number',
  再次确认后将替换之前的优惠: 'After confirmation, it will replace the previous discount',
  请输入数字或字母的组合: 'Please enter a combination of numbers or letters',
  '我的订单-下单': 'My order-place an order',
  '是否删除当前优惠券信息？': 'Delete current coupon information?',
  无优惠: 'No discount',
  缺少参数: 'Lack of parameters',
  '{slot1}天': '{slot1} days',
  '{slot1}年': '{slot1} years',
  '{slot1}月': '{slot1} months',
  无法使用大于等于订单金额的优惠券: 'Coupons greater than or equal to the order amount cannot be used',
  '优惠{slot1}元': '{slot1} yuan discount',
  '打{slot1}折': '{slot1}% off',
  线上: 'Online',
  生成订单失败: 'Failed to generate order',
  请选择收货地址: 'Please select the shipping address',
  请选择订单生效时间: 'Please select the order effective time',
  '产品价格发生变更，请点击确定，页面将自动刷新！': 'The product price has changed. Click OK and the page will refresh automatically!',
  纳税人识别号请输入15或18位数字或字母的组合: 'The taxpayer ID must be 15 or 18 digits or a combination of letters and numbers',
  '订单类型：': 'Order type:',
  所有订单: 'All orders',
  生效中订单: 'Effective orders',
  待生效订单: 'Pending orders',
  已失效订单: 'Expired orders',
  待支付订单: 'Pending payment orders',
  已终止订单: 'Terminated orders',
  历史授权: 'Historical authorization',
  暂无记录: 'No record',
  '搭售-主订单号：': 'Bundling-main order number:',
  '子产品价格:': 'Sub-product price:',
  '份/年': 'copies/year',
  '元/份/年': 'yuan/copy/year',
  '元/份': 'yuan/copy',
  '延时订单：': 'Delayed order:',
  '搭售-主商品：': 'Bundling-main product:',
  订单数量: 'Order quantity',
  订单状态: 'Order status',
  下载请求失败: 'Download request failed',
  搭售: 'Bundling',
  售后赔偿: 'After-sales compensation',
  增加时长: 'Add duration',
  试用: 'Trial',
  免费数量: 'Free quantity',
  我的余额: 'My balance',
  我的返佣: 'My rebate',
  '当前余额:': 'Current balance:',
  提现: 'Withdraw',
  提现明细: 'Withdrawal details',
  资金账户: 'Fund account',
  '余额（元）': 'Balance (Yuan)',
  '可用余额:': 'Available balance:',
  详情: 'Details',
  '提现中：': 'Withdrawing:',
  '状态：': 'Status:',
  全部: 'All',
  收入: 'Income',
  支出: 'Expenditure',
  '时间：': 'Time:',
  '1个月': '1 month',
  半年: 'Half year',
  '1年': '1 year',
  '资金账户：': 'Fund account:',
  流水号: 'Serial number',
  日期: 'Date',
  '收入(元)': 'Income (Yuan)',
  '支出(元)': 'Expenditure (Yuan)',
  '余额(元)': 'Balance (Yuan)',
  支付方式: 'Payment method',
  项目: 'Project',
  购买产品: 'Purchase product',
  线上充值: 'Online recharge',
  消费结算: 'Consumption settlement',
  线下充值: 'Offline recharge',
  提现成功: 'Withdrawal successful',
  发票快递费: 'Invoice postage',
  代理返佣: 'Agent rebate',
  线下退款: 'Offline refund',
  渠道合作: 'Channel cooperation',
  退款转入: 'Refund transfer',
  ' 余额钱包': 'Balance wallet',
  ' 返佣钱包': 'Commission wallet',
  '您还不是超级管理员，无法进行提现操作！': 'You are not a super administrator and cannot make withdrawals!',
  '为保障您主体账户资金安全，当天仅能操作1次提现，今日提现次数已用完！':
    "To ensure the safety of your main account funds, only one withdrawal operation can be performed per day, and today's withdrawal limit has been reached!",
  '您于{slot1}发起的提现申请失败，失败原因为：{slot2}。': 'Your withdrawal request initiated on {slot1} failed due to: {slot2}.',
  份: 'Pieces',
  电子签名: 'Electronic signature',
  SaaS签署流量包: 'SaaS signature traffic package',
  '轩辕签署服务（企业版）': 'Xuanyuan signature service (enterprise version)',
  企业10份: '10 copies for enterprises',
  北京金格: 'Beijing Kingsoft',
  充值: 'Recharge',
  '充值金额:': 'Recharge amount:',
  请输入充值金额: 'Please enter the amount to be recharged',
  '支付方式:': 'Payment method:',
  支付宝: 'Alipay',
  确认充值: 'Confirm recharge',
  请填写充值金额: 'Please fill in the recharge amount',
  '请填写正确的充值金额，保留2位有效数字': 'Please fill in the correct recharge amount with 2 decimal places',
  请选择支付方式: 'Please select a payment method',
  '需支付金额:': 'Amount to be paid:',
  '元 (快递费)': 'Yuan (express fee)',
  查看历史结算详单: 'View historical settlement details',
  使用余额支付: 'Use balance to pay',
  '我的账户余额:': 'My account balance:',
  请输入签署密码进行支付: 'Please enter the signature password for payment',
  '还没有签署密码?': "Don't have a signature password yet?",
  去设置签署密码: 'Set signature password',
  使用第三方支付: 'Use third-party payment',
  微信: 'WeChat',
  对公支付: 'Public payment',
  银行转账: 'Bank transfer',
  确认支付: 'Confirm payment',
  恭喜你下单支付成功: 'Congratulations on your successful payment.',
  '请立即添加官方企微，协助您上线生效套餐。': 'Please add an official WeChat account immediately to help you launch the effective package.',
  '首次添加另可以赠送证据报告一份，用于向对方说明电子合同有效性。':
    'For the first time, you can also present a copy of evidence report to explain the validity of the electronic contract to the other party.',

  历史结算清单: 'Historical settlement list',
  支付记录号: 'Payment record number',
  费用: 'Fee',
  支付状态: 'Payment status',
  专属汇款账号: 'Exclusive remittance account number',
  '证明文件正在生成中，请勿关闭当前页面': 'Proof documents are being generated, please do not close the current page',
  '平台收到银行汇款后十分钟内将自动匹配到您的订单，并为您完成支付。注：专属汇款账号是在平台发票信息显示账号下设立的子账号，二者为同一账号。':
    'After the bank remittance is received by the platform, it will be automatically matched to your order within ten minutes, and the payment will be completed for you. Note: The exclusive remittance account is a sub-account established under the platform invoice information display account, and the two are the same account.',
  '您选择对公支付，请使用企业账户汇款，如使用个人账户可能有失败风险！':
    'If you choose public payment, please use the corporate account for remittance. There may be a risk of failure if you use a personal account!',
  '开户名称：': 'Account name:',
  '开户银行：': 'Bank name:',
  '专属汇款账号：': 'Exclusive remittance account number:',
  '付款金额：': 'Payment amount',
  一键复制账户信息: 'Copy account information with one click',
  下载专属帐号电子证明: 'Download exclusive account electronic certificate',
  '您选择对公支付，需要在72小时内完成汇款到账，超过时订单将会关闭，请勿多汇款或少汇款！':
    'If you choose public payment, please complete the remittance within 72 hours. If it exceeds the time, the order will be closed. Please do not remit more or less!',
  '微信支付(请用微信扫描二维码)': 'WeChat payment (please scan the QR code with WeChat)',
  支付成功: 'Payment successful',
  '账户信息已经复制成功，您可以发送给打款人进行汇款！':
    'Account information has been successfully copied. You can send it to the payer for remittance!',
  证明文件生成完成: 'Proof documents generated',
  '证明文件生成超时，请重试': 'Proof document generation timed out, please try again',
  '支付宝支付(请用支付宝扫描二维码)': 'Alipay payment (please scan the QR code with Alipay)',
  转售开始时间: 'Start time',
  授权开始时间: 'Start time',
  转售结束时间: 'End time',
  授权结束时间: 'End time',
  授权状态: 'Status',
  授权方式: 'Method',
  授权方: 'Authorized party',
  被转售方名称: 'Resold name',
  被授权方名称: 'Authorized name',
  转售时间: 'Time',
  授权时间: 'Time',
  授权量: 'Quantity',
  状态: 'Status',
  授权中: 'Authorizating',
  开通: 'Enable',
  查看: 'View',
  备注: 'Remarks',
  查看物流: 'Logistics',
  设置备注: 'Set remarks',
  请输入备注内容: 'Please enter remark content',
  已成功开通子服务项: 'Sub-service items have been successfully enabled',
  最大输入40个字符: 'Maximum of 40 characters',
  '请确认是否取消“{slot1}”订单的授权，取消后，收回当前授权量的管理,可能会影响“{slot2}”使用。':
    'Please confirm whether to cancel the authorization of the "{slot1}" order. After cancellation, the management of the current authorization quantity may affect the use of "{slot2}".',
  取消授权: 'Cancel authorization',
  订单: 'Order',
  转售: 'Resale',
  确认: 'Confirm',
  订单转售: 'Order resale',
  转售确认: 'Resale confirmation',
  授权确认: 'Authorization confirmation',
  确认转售: 'Confirm',
  确认授权: 'Confirm',
  '可使用方：': 'Usable by:',
  '本次新增的被转售方信息如下：': 'The following is the newly added information of the resale party:',
  被转售方: 'Resale party',
  被授权方: 'Authorized party',
  '授权订单总量/最大可用量': 'Total quantity of authorized order / maximum available quantity',
  '授权须知：': 'Authorization notes:',
  '在操作本转赠功能之前，请您仔细阅读本提醒内容，您实际使用了本功能即视为您已经阅读并认可本提醒内容；若您不接受本提醒内容，请您不要进行下一步操作。':
    'Before using this transfer function, please read this reminder carefully. Your actual use of this function is deemed to be your reading and acceptance of this reminder content; if you do not accept this reminder content, please do not proceed to the next step.',
  '1、本授权指：我司可将我司购买的e签宝服务中的全部或部分授权给我司提供的名单中的关联公司或合作伙伴。我司与授权使用方之间的法律关系由我司与授权使用方自行确认。':
    '1. This authorization refers to: Our company can authorize all or part of the eSign services purchased by our company to the related companies or partners listed by our company. The legal relationship between our company and the authorized user is confirmed by our company and the authorized user.',
  '2、授权使用方使用e签宝服务的内容在e签宝提供的产品范围内，由我司确认。我司无条件接受e签宝调整可授权的产品范围，其影响由我司自行承担。':
    '2. The content of using eSign services by the authorized user is confirmed by our company within the product range provided by eSign. Our company unconditionally accepts the adjustment of the product range that eSign can authorize, and the impact is borne by our company.',
  '3、开通订单授权功能及进行授权，不改变我司与e签宝签署的《软件技术服务协议》等合同的权利义务关系，另有约定的除外。':
    '3. Enabling the order authorization function and authorizing it does not change the rights and obligations relationship of the contracts such as the "Software Technical Service Agreement" signed between our company and eSign, except as otherwise agreed.',
  '4、我司确保授权使用方完成实名认证，并按照电子签名法的要求合法合规使用电子签名服务。':
    '4. Our company ensures that the authorized user has completed real-name verification and uses the electronic signature service legally and compliantly in accordance with the requirements of the Electronic Signature Law.',
  '5、我司知悉e签宝非标类产品需要增购e签宝提供的《电子证据法律咨询服务》或《互联网业务流程公证服务》，我司确保可授权用户已经增购相应产品，否则贵司有权立刻关闭授权功能。':
    '5. Our company knows that non-standard products of eSign require the purchase of eSign\'s "Electronic Evidence Legal Advisory Service" or "Internet Business Process Notarization Service", and our company ensures that authorized users have purchased the corresponding products. Otherwise, your company has the right to immediately close the authorization function.',
  '转售须知：': 'Resale notes:',
  '在操作本转售功能之前，请您仔细阅读本提醒内容，您实际使用了本功能即视为您已经阅读并认可本提醒内容；若您不接受本提醒内容，请您不要进行下一步操作。':
    'Before using this resale function, please read this reminder carefully. Your actual use of this function is deemed to be your reading and acceptance of this reminder content; if you do not accept this reminder content, please do not proceed to the next step.',
  '1、使用本功能，您可以将您所购买的e签宝服务中的全部或部分转售给您的关联公司、合作伙伴或者客户使用。':
    '1. With this function, you can resell all or part of the eSign services you purchased to your related companies, partners or customers for use.',
  '2、使用本功能，不会改变您和e签宝所签署软件产品相关服务合同之权利义务关系，您需合法的使用该转售功能并自行对您的行为负责。':
    '2. Using this function will not change the rights and obligations relationship between you and eSign related service contracts. You should legally use this resale function and be responsible for your behavior.',
  '3、您应确保您的转售使用方完成实名认证并按照电子签名法的要求合法合规的使用电子签名服务，e签宝不对您的转售使用方未按照法律规定使用电子签名的行为负责。':
    '3. You should ensure that your reselling users complete real-name verification and use electronic signature services in accordance with the requirements of the Electronic Signature Law. Esign does not take responsibility for any behavior of your reselling users that does not comply with the legal requirements for using electronic signatures.',
  '4、使用本功能，您应确保您已获得转售使用方给予您查看其使用电子签名签署记录的相关授权，并由您自行维护您与转售使用方间包括但不限于订单余额提醒、续充维护、隐私保护、费用结算、开票及其他相关服务，由此引发的争议由您自行处理，e签宝不承担任何责任。':
    '4. By using this feature, you should ensure that you have obtained the relevant authorization from your reselling users to view their electronic signature signing records. You should also maintain your own services with your reselling users, including but not limited to order balance reminders, recharge maintenance, privacy protection, fee settlement, invoicing, and other related services. Any disputes arising from this should be handled by you, and Esign is not responsible for any of them.',
  '5、因您的转售使用方与e签宝不存在合同关系，故您与您的转售使用方之间的法律关系由您自行负责，e签宝不向您的转售使用方提供出证等法律服务，您因确保您的转售使用方知晓并同意。':
    '5. Since there is no contractual relationship between your reselling users and Esign, the legal relationship between you and your reselling users is your responsibility. Esign does not provide any legal services such as certification to your reselling users. You should ensure that your reselling users understand and agree to this.',
  '6、您因转售行为导致您的转售使用方不能正常使用电子签名服务或因使用服务引发纠纷的，您应自行处理，若因此给e签宝造成损失的，e签宝有权向您进行追偿。':
    '6. If your reselling behavior causes your reselling users to be unable to use electronic signature services normally or causes disputes due to the use of services, you should handle them yourself. If this causes losses to Esign, Esign has the right to recover from you.',
  '7、e签宝保留随时关闭该功能的权利。': '7. eSign reserves the right to close this function at any time.',
  请输入签署密码进行: 'Please enter the signature password for',
  请输入签署密码进行授权: 'Please enter the signature password for authorization',
  确认授权成功: 'Confirm authorization success',
  确认转售成功: 'Confirm resale success',
  提交: 'Submit',
  重置: 'Reset',
  '有效期{year}年': 'Validity period {year} years',
  有效期无限: 'Unlimited validity period',
  购买份数: 'Purchase copies',
  商品标准价格: 'Standard product price',
  优惠券: 'Coupon',
  已优惠: 'Discounted',
  实际支付金额: 'Actual payment amount',
  订单生效时间: 'Order effective time',
  '您可以设置订单开始生效时间，即以此时间开始方可使用相关服务。':
    'You can set the starting time of the order, and the relevant services can only be used after this time.',
  '{value} 年': '{value} year',
  '{value} 月': '{value} month',
  '{value} 日': '{value} day',
  优惠码: 'Coupon code',
  余额支付: 'Balance payment',
  '对不起！您的账户余额不足。': 'Sorry! Your account balance is insufficient.',
  '折扣{slot1}%': '{slot1}% discount',
  '产品价格发生变更，请点击确定，页面将自动刷新': 'The product price has changed, please click OK',
  支付宝支付: 'Alipay Payment',
  微信支付: 'WeChat Payment',
  请确认支付是否完成: 'Please confirm whether the payment is completed',
  已完成支付: 'Payment completed',
  遇到问题重新支付: 'If you encounter any problems, please retry the payment',
  购买成功: 'Purchase successful',
  '正在获取支付结果，请稍后': 'Getting payment result, please wait',
  '支付失败，请重新尝试支付': 'Payment failed, please try again',
  用户取消: 'User canceled',
  超时取消: 'Timeout canceled',
  异常终止: 'Abnormal termination',
  '总金额:': 'Total amount:',
  主体: 'Subject',
  产品购买合同: 'Product purchase contract',
  商务代表: 'Business representative',
  联系电话: 'Contact number',
  订单ID: 'Order ID',
  商品名称: 'Product name',
  '订单规格（份）': 'Order specification (copy)',
  '（按量后付）': '(Post-payment by quantity)',
  '订单成交总金额（元）': 'Total transaction amount (Yuan)',
  '（已出账）': '(Billed)',
  '已付款金额（元）': 'Amount paid (Yuan)',
  '本次应支付金额（元）': 'Amount to be paid this time (Yuan)',
  '《e签宝产品购买协议》': 'eSign purchase agreement',
  确认购买信息: 'Confirm purchase information',
  线下转账: 'Offline transfer',
  公司名称: 'Company name',
  杭州天谷信息科技有限公司: 'Hangzhou Tiangu Information Technology Co., Ltd.',
  税号: 'Tax ID',
  '浙江省杭州市西湖区西斗门路3号 天堂软件园D幢19层':
    '19th Floor, Building D, Sky Software Park, No.3 Xidoumen Road, Xihu District, Hangzhou, Zhejiang Province',
  平安银行杭州高新支行: 'Ping An Bank Hangzhou Gaoxin Branch',
  您可以通过网银或柜台直接将相应金额转账至e签宝银行账户:
    'You can transfer the corresponding amount directly to the eSign bank account through online banking or at the counter',
  请用浏览器打开: 'Please use a browser to open',
  '请确认是否选择下线转账，确认后将不能线上支付，同时，也会完成邀请支付':
    'Please confirm whether to choose offline transfer. Once confirmed, you cannot pay online, and the invitation payment will also be completed',
  '您已选择线下支付，': 'You have chosen offline payment,',
  支付成功后订单状态将会更新: 'The order status will be updated after successful payment',
  线下转账信息: 'Offline transfer information',
  复制: 'Copy',
  订单规格: 'Order specification',
  复制成功: 'Copy successful',
  '本次总需支付金额：': 'Total amount to be paid this time:',
  '商务代表：': 'Business representative:',
  '我已阅读，同意此': 'I have read and agreed to this',
  '(您可以通过网银或柜台直接将相应金额转账至e签宝银行账户)':
    '(You can transfer the corresponding amount directly to the eSign bank account through online banking or at the counter.)',
  '公司名称：': 'Company name:',
  '税号：': 'Tax ID:',
  '地址：': 'Address:',
  浙江省杭州市西湖区西斗门路3号天堂软件园D幢19层:
    '19th Floor, Building D, Heaven Software Park, No. 3 Xidoumen Road, Xihu District, Hangzhou, Zhejiang Province',
  '电话：': 'Phone:',
  '银行账号：': 'Bank account:',
  确认支付方式: 'Confirm payment method',
  文件: 'Document',
  '（{slot1}份）': '({slot1} copy)',
  '您已选择线下支付，支付成功后订单状态将及时更新':
    'You have chosen offline payment. The order status will be updated in time after successful payment',
  '恭喜！您已支付成功！': 'Congratulations! You have successfully paid!',
  '提示：您可以通过e签宝官网在': 'Note: You can access the eSign website ',
  '中查看相关订单及使用情况。': ' view relevant orders and usage.',
  '抱歉，支付失败！': 'Sorry, payment failed!',
  '失败原因：': 'Reason for failure:',
  '请稍等，支付确认中…': 'Please wait, payment confirmation in progress...',
  '线下转账支付信息：': 'Offline transfer payment information:',
  '支付信息已复制成功，直接操作粘贴即可。': 'Payment information has been successfully copied, just paste to operate.',
  '恭喜，您的开票申请已提交成功！': 'Congratulations, your invoice application has been submitted successfully!',
  查看全部订单: 'View all orders',
  '合并开票订单：': 'Consolidate invoice orders:',
  '{slot1}，按归属公司分别合并开票': '{slot1}, Separate consolidated billing according to the company of ownership',
  归属公司: 'Affiliated company',
  '订单金额(元)': 'Order amount (Yuan)',
  电子发票已开: 'Electronic invoice issued',
  开票失败: 'Invoice failed',
  获取发票: 'Get invoice',
  '由于您的开票申请涉及未全额付款订单，因此需要2个工作日的审批后开具！':
    'Because your invoice application involves orders with unpaid amounts, it takes 2 working days to approve the application before issuing the invoice!',
  '（请在订单管理中及时获取开具的电子发票）': '(Please obtain the issued electronic invoice in a timely manner in the order management)',
  '提示：您申请开具的发票将在7个工作日内寄出，请注意查收！':
    'Note: The invoice you applied for will be mailed within 7 working days. Please check it in time!',
  支付结果: 'Payment result',
  '若您尚未完成企业实名认证，该产品将无法正常启用':
    'If you have not completed the enterprise real-name verification, this product will not be able to start normally',
  '商品正在加紧备货，预计1-2周发出': 'The product is being prepared urgently and is expected to be shipped in 1-2 weeks',
  查看余额: 'View balance',
  重新支付: 'Retry payment',
  支付遇到问题: 'Payment issues',
  '发票抬头：': 'Invoice title:',
  订单金额: 'Order amount',
  警告: 'Warning',
  '若您尚未完成企业实名认证，该产品将无法正常启用！':
    'If you have not completed the enterprise real-name verification, this product will not be able to start normally!',
  支付失败: 'Payment failed',
  '暂不支持这个method：{slot1}': 'This method is not supported at the moment: {slot1}',
  天: 'Day',
  '微应用 demo': 'Mini App demo',
  文件hash: 'Sign hash',
  '导出结果中暂不包含当日耗用数据，敬请谅解':
    'The export results do not currently include the consumption data of the current day. We apologize for any inconvenience caused',
  提交成功: 'Submitted successfully',
  '系统将在2个工作日内将对应消费记录发送到对应邮箱，或可查询已导出记录进行自助下载':
    'The system will send the corresponding consumption records to the corresponding email within 2 working days, or the exported records can be queried for self-service download',
  '解压密码为：': 'The decompression password is:',
  文件名: 'File name',
  导出时间: '  Export Time',
  导出结果: 'Export Results',
  解压密码: 'Decompress password',
  未加密: 'Unencrypted',
  导出中: 'Exporting',
  请输入正确的邮箱地址: 'Please enter the correct email address',
  已授权: 'Authorized',
  未授权: 'unauthorized',
  系统异常: 'System abnormality',
  '订单上线提醒：': 'Order Launch Reminder:',
  '1、订单上线后，所购商品套餐有效期不可更改与延期。':
    '1、Once an order is launched, the validity period of the purchased product package cannot be changed or extended.',
  '2、如有接口对接，建议在系统完整对接完，再进行订单上线。':
    '2、If there is an interface integration involved, it is recommended to complete the full integration and testing of the systems before launching the order.',
  汇款账户信息: 'Remittance Account Information',
  请先阅读并同意协议: 'Please read and agree to the agreement first',
  收款户名: 'Beneficiary Name',
  收款银行: 'Beneficiary Bank',
  汇款账号: 'Remittance Account Number',
  复制账户信息: 'Copy Account Information',
  '收款户名：': 'Beneficiary Name:',
  '收款银行：': 'Beneficiary Bank:',
  '汇款账号：': 'Remittance Account Number:',
  兑换优惠券: 'Redeem Coupon',
  请输入优惠券码: 'Please Enter the Coupon Code',
  确认兑换: 'Confirm Redemption',
  发票信息: 'Invoice Information',
  开票银行: 'Issuing Bank',
  请选择开票银行: 'Please Select the Issuing Bank',
  '邮箱地址：': 'Email Address:',
  请输入正确的银行账号: 'Please Enter the Correct Bank Account Number',
  请输入正确的手机号码: 'Please Enter the Correct Mobile Phone Number',
  '纳税人识别号：': 'Taxpayer ID:',
  '开户行：': 'Bank of Deposit:',
  '开票电话：': 'Invoice phone number:',
  '发票类型：': 'Invoice type:',
  '发票形式：': 'Invoice format:',
  '开票地址：': 'Invoice address:',
  修改开票信息: 'Modify Invoice Information',
  收货地址: 'Shipping Address',
  '地址信息：': 'Address Information:',
  '详细信息：': 'Detailed Information:',
  '收货人：': 'Recipient:',
  选择收货地址: 'Select Shipping Address',
  新建地址: 'Create New Address',
  选择其他地址: 'Select Other Address',
  使用新地址: 'Use New Address',
  企业账户: 'Corporate Account',
  确认订单: 'Confirm Order',
  支付: 'Pay',
  '抱歉，单次发票可开具金额为1999999.99，请联系客服获取发票。':
    'Sorry, the maximum amount that can be invoiced for a single invoice is 1,999,999.99. Please contact customer service to obtain the invoice.',
  倒计时: 'Countdown',
  '支付超时已关闭，你可重新下单': 'The payment timeout has been closed. You can place the order again.',
  '{time}后支付关闭': ' the payment will be closed in <span class="countdown-time">{time}</span>',
  '支付遇到问题？': 'Having trouble with payment?',
  点击获取客服支持: 'Click to Get Customer Service Support',
  永久有效: 'Permanent Validity',
  '已为该订单生成专属汇款账号，是平台收款账号下设的专属子账号。':
    "A dedicated remittance account has been generated for this order, which is a dedicated sub-account under the platform's receiving account.",
  下载证明: 'Download Certificate',
  '请准确按照订单金额对公汇款；': 'Please remit to the public account accurately according to the order amount;',
  '72小时内未转账成功订单会超时关闭。': 'If the transfer is not successful within 72 hours, the order will be closed due to timeout.',
  '汇款成功后，订单将在10分钟内生效': 'After the remittance is successful, the order will take effect within 10 minutes.',
  '去转账，等待支付结果': 'Go to Transfer and Wait for the Payment Result',
  修改签署密码: 'Modify the Signing Password',
  '银行转账（对公支付）': 'Bank Transfer (Corporate Payment)',
  账户余额支付: 'Account Balance Payment',
  使用支付宝扫码支付: 'Scan the QR code to pay with Alipay',
  使用微信扫码支付: 'Scan the QR code to pay with WeChat',
  商品总价: 'Total Product Price',
  优惠: 'Discount',
  输入优惠券码: 'Enter Coupon Code',
  暂无优惠: 'No Discount Available',
  不使用优惠: 'Do Not Use Discount',
  '实付款：': 'Actual Payment:',
  服务协议: 'Service Agreement',
  立即支付: 'Pay Now',
  余额: 'Balance',
  优惠券已存在: 'The Coupon Already Exists',
  产品信息: 'Product Information',
  '订阅内容：': 'Subscription Content:',
  '有效期：': 'Validity Period:',
  '产品规格：': 'Product specifications:',
  购买主体: 'Purchasing Entity',
  生效时间: 'Effective Date',
  '当前有生效中的订单，{data}到期': 'There is currently an effective order, which will expire on {data}',
  '续延订单在原订单结束后生效，或原订单提前消耗完续延订单自动生效。':
    'The continued order will take effect after the original order ends, or the continued order will automatically take effect if the original order is consumed in advance. ',
  购买数量: 'Purchase Quantity',
  指定时间生效: 'Effective at Specified Time',
  订单续延生效: 'Order Continuation and Effective',
  订单完成后开发票: 'Issue an Invoice After the Order is Completed',
  填写发票信息: 'Fill in Invoice Information',
  订单列表: 'order list',
  微信扫码添加官方客服微信: 'Scan the QR code with WeChat to Add the Official Customer Service WeChat Account',
  首次添加可赠送证据报告一份: 'A copy of the evidence report will be given as a gift for the first addition.',
  企业微信: 'Corporate WeChat',
  转账结果确认中: 'The transfer result is being confirmed.',
  '汇款成功后，订单将在10分钟内生效，请耐心等待':
    'After the remittance is successful, the order will take effect within 10 minutes. Please wait patiently.',
  '开票银行：': 'Issuing bank:',
  '预计1-2周发出': 'Expected to be sent out within 1-2 weeks',
  账户信息复制成功: 'Account information has been successfully copied.',
  实际使用方: 'Actual Use',
  剩余量: 'Remaining Quantity',
  '当前登录的企业和购买链接所属的企业（{epBindOrgName}）不一致，请选择正确企业空间或者重新登录':
    'The current enterprise you are logged in and the enterprise specified in the purchase link ({epBindOrgName}) do not match. Please select the correct enterprise space or log in again.',
  专属特惠: 'Exclusive Discount',
  原价: 'original price',
  '顺手购活动暂不支持对公转账，请选择其他方式支付': 'Please note that corporate transfer is not currently supported for the Handy Purchase activity. Please choose another payment method.',
  配置生效时间: 'Configuration Effective Time',
  '配置生效时间后，商品套餐有效期不可更改或延期！若涉及接口对接等前置流程，建议系统对接完成后再配置生效': 'After configuring the effective time, the validity period of the commodity package cannot be changed or extended! If interface docking and other pre-process are involved, it is recommended that the configuration takes effect after the system docking is completed.',
  '订单生效时间配置后不可更改或延期，确认配置？': 'Order effective time cannot be changed or postponed after configuration. Confirm configuration?',
  '暂不配置': 'Not configured temporarily',
  '根据税务局相关规定，软件类产品需单独开具发票，因此您可能会收到同一服务主体出具的多张发票，所有发票均真实有效，可正常使用。': 'According to the relevant regulations of the tax bureau, software products need to be invoiced separately, so you may receive multiple invoices issued by the same service entity, all invoices are true and valid, and can be used normally.',
}
